document.addEventListener("DOMContentLoaded", function () {
    const btnTopo = document.getElementById("btn-voltar-topo");
  
    window.addEventListener("scroll", function () {
      if (window.scrollY > 300) {
        btnTopo.style.display = "flex";
      } else {
        btnTopo.style.display = "none";
      }
    });
  
    btnTopo?.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  });
  